var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 10.6063C19.7937 10.5445 19.132 9.07656 17.6609 7.60547C15.7008 5.64531 13.225 4.60938 10.5 4.60938C7.77499 4.60938 5.29921 5.64531 3.33906 7.60547C1.86796 9.07656 1.20312 10.5469 1.1789 10.6063C1.14336 10.6862 1.125 10.7727 1.125 10.8602C1.125 10.9476 1.14336 11.0341 1.1789 11.1141C1.20624 11.1758 1.86796 12.643 3.33906 14.1141C5.29921 16.0734 7.77499 17.1094 10.5 17.1094C13.225 17.1094 15.7008 16.0734 17.6609 14.1141C19.132 12.643 19.7937 11.1758 19.8211 11.1141C19.8566 11.0341 19.875 10.9476 19.875 10.8602C19.875 10.7727 19.8566 10.6862 19.8211 10.6063ZM10.5 13.9844C9.88193 13.9844 9.27774 13.8011 8.76384 13.4577C8.24993 13.1143 7.84939 12.6263 7.61287 12.0553C7.37635 11.4842 7.31446 10.8559 7.43504 10.2497C7.55562 9.64353 7.85325 9.08671 8.29028 8.64967C8.72732 8.21263 9.28415 7.915 9.89034 7.79442C10.4965 7.67384 11.1249 7.73573 11.6959 7.97225C12.2669 8.20878 12.755 8.60931 13.0983 9.12322C13.4417 9.63712 13.625 10.2413 13.625 10.8594C13.625 11.6882 13.2958 12.483 12.7097 13.0691C12.1237 13.6551 11.3288 13.9844 10.5 13.9844Z",
    fill: "#B2B2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.615612778492748c933c17d45ef8884c.svg";
export { ForwardRef as ReactComponent };